import styled from 'styled-components';

export const EProtectPayframe = styled.div`
  width: 400px;

  @media (max-width: 767px) {
    max-width: 100%;
    width: 320px;
  }
`;
